import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, PanelGroup} from 'react-bootstrap'
import cx from 'classnames'
import ButtonToggle from '../../core/components/ButtonToggle'
import matcher from '../../core/matcher'
import Icon from '../../core/components/Icon'
import IconCateg from '../../core/components/IconCateg'
import {OpeningTicketPurposeRef} from '../models'
import i18n from '../i18n'
import UpdateOpeningTicketPurposePanel from './UpdateOpeningTicketPurposePanel'
import CreateOpeningTicketPurposePanel from './CreateOpeningTicketPurposePanel'
import CreateUpdateTagModal from './CreateUpdateTagModal'
import CreateUpdateCategoryModal from './CreateUpdateCategoryModal'
import AssociateActivityWithOpeningTicketPurposeModal from './AssociateActivityWithOpeningTicketPurposeModal'
import DissociateActivityFromOpeningTicketPurposeModal from './DissociateActivityFromOpeningTicketPurposeModal'
import EnableDisableOpeningTicketPurposeModal from './EnableDisableOpeningTicketPurposeModal'
import style from './OpeningTicketPurposePanelGroup.less'

class ModalDeferred {
    constructor(openResult) {
        var expectedCloseResult
        switch (openResult) {
            case 'CreateCategory':
                expectedCloseResult = 'CategoryCreated'
                break
            case 'CreateTag':
                expectedCloseResult = 'TagCreated'
                break
        }

       this.promise = new Promise((resolve, reject)=> {
            
            this.resolve = function(closeResult, value) {
                if (expectedCloseResult == closeResult) {
                    resolve(value)
                }
            }
        })
    }
}

function modalName(result) {
    switch (result) {
        case 'CreateCategory':
            return 'CreateUpdateCategoryModal'
        case 'CreateTag':
            return 'CreateUpdateTagModal'
        case 'AssociateActivityWithOpeningTicketPurpose':
            return 'AssociateActivityWithOpeningTicketPurposeModal'
        case 'DissociateActivityFromOpeningTicketPurpose':
            return 'DissociateActivityFromOpeningTicketPurposeModal'
        case 'EnableDisableOpeningTicketPurpose':
            return 'EnableDisableOpeningTicketPurposeModal'
        default:
            return null
    }
}

function activeValues(result, value) {
    switch (result) {
        case 'CreateCategory':
            return {activeCategory: value}
        case 'CreateTag':
            return {activeTag: value}
        case 'AssociateActivityWithOpeningTicketPurpose':
            return {activeOpeningTicketPurpose: value}
        case 'DissociateActivityFromOpeningTicketPurpose':
            return {activeOpeningTicketPurpose: value.openingTicketPurpose, activeActivity: value.activity}
        case 'EnableDisableOpeningTicketPurpose':
            return {activeOpeningTicketPurpose: value}
        default:
            return null
    }
}

function openingTicketPurposeFilter(categories, tags) {
    return (openingTicketPurpose) => {
        for (var i = 0 ; i < tags.length ; i++) {
            if (!openingTicketPurpose.tags.find((t) => t.uid == tags[i].uid)) return false
        }
        for (var i = 0 ; i < categories.length ; i++) {
            if (openingTicketPurpose.categories.find((c) => c.uid == categories[i].uid)) return true
        }
        return (categories.length == 0) && true || false
    }
}

function openingTicketPurposeSorter(reference) {
    return (a, b) => {
        if (reference.default.openingTicketPurpose.uid == a.uid) return 1
        if (reference.default.openingTicketPurpose.uid == b.uid) return -1
        return a.label.localeCompare(b.label)
    }
}

function tagAggregator(reference, tags) {
    return (result, openingTicketPurpose) => {
        openingTicketPurpose.tags.forEach((tag) => {
            var aggrega = result.find((a) => a.tag.uid == tag.uid)
            if (aggrega) {
                aggrega.count++
                return
            }

            var tagz = tags.find((t) => t.uid == tag.uid)
            if (tagz) {
                return
            }

            tagz = reference.tags.find((t) => t.uid == tag.uid)
            if (!tagz) {
                console && console.warn('tag "' + tag.uid + '" doesn\'t exist in referentiel')
                return
            }

            aggrega = {
                tag: tagz,
                count: 1
            }
            result.push(aggrega)
        })
        return result
    }
}

function categoryAggregator(reference, parentCategory) {
    return (result, openingTicketPurpose) => {
        openingTicketPurpose.categories.forEach((category) => {
            const categoryz = reference.categories.find((c) => c.uid == category.uid)
            if (!categoryz) {
                console && console.warn('category "' + category.uid + '" doesn\'t exist in referentiel')
                return
            }

            const categoryPath = OpeningTicketPurposeRef.expendParentCategories(reference, categoryz)
            const ancestorCategory = OpeningTicketPurposeRef.truncCategoryPath(categoryPath, parentCategory)[0]

            if (!ancestorCategory) {
                return
            }

            var aggrega = result.find((a) => a.category.uid == ancestorCategory.uid)
            if (aggrega) {
                return
            }

            aggrega = {
                category: ancestorCategory
            }

            result.push(aggrega)
        })
        return result
    }
}

function defaultTagAggregation(reference, tags) {
    const defaultTag = reference.default.tag

    if (!tags.find((t) => t.uid == defaultTag.uid)) {
        return [{
            tag: defaultTag,
            count: 1000
        }]
    }
    return []
}

function defaultTagCriteria(reference, tags) {
    const defaultTag = reference.default.tag

    if (tags.find((t) => t.uid == defaultTag.uid)) {
        return {
            tags: [defaultTag],
            category: null
        }
    }
    return {tags}
}

function categoryOrTagMatcher(categoryOrTags) {
    return matcher({
        source: categoryOrTags,
        identify: (cot) => cot.label
    })
}

class OpeningTicketPurposePanelGroup extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            criteria: {
                tags: []
            }
        }
    }

    componentWillMount() {
        const {openingTicketPurposeReference} = this.props
        const {criteria} = this.state
        
        const openingTicketPurposes = [...openingTicketPurposeReference.openingTicketPurposes, openingTicketPurposeReference.default.openingTicketPurpose]
        const filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(OpeningTicketPurposeRef.expendChildrenCategories(openingTicketPurposeReference, criteria.category), criteria.tags))
        const sortedOpeningTicketPurposes = filteredOpeningTicketPurposes.sort(openingTicketPurposeSorter(openingTicketPurposeReference))
        const tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(openingTicketPurposeReference, criteria.tags), defaultTagAggregation(openingTicketPurposeReference, criteria.tags))
        const filteredTags = tagAggregation.sort((a, b) => b.count - a.count).map((a) => a.tag)
        const filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(openingTicketPurposeReference, criteria.category), []).map((a) => a.category)
        const categorySource = categoryOrTagMatcher(filteredCategories)
        const tagSource = categoryOrTagMatcher(filteredTags)

        categorySource(null, (categoryMatches) => {
            tagSource(null, (tagMatches) => {
                this.setState({sortedOpeningTicketPurposes, categorySource, tagSource, categoryMatches, tagMatches})
            })
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference) {
            const {openingTicketPurposeReference} = nextProps
            const {criteria, activeOpeningTicketPurpose} = this.state
            
            const nextActiveOpeningTicketPurpose = activeOpeningTicketPurpose && openingTicketPurposeReference.openingTicketPurposes.find((otp) => otp.uid == activeOpeningTicketPurpose.uid)

            const openingTicketPurposes = [...openingTicketPurposeReference.openingTicketPurposes, openingTicketPurposeReference.default.openingTicketPurpose]
            const filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(OpeningTicketPurposeRef.expendChildrenCategories(openingTicketPurposeReference, criteria.category), criteria.tags))
            const sortedOpeningTicketPurposes = filteredOpeningTicketPurposes.sort(openingTicketPurposeSorter(openingTicketPurposeReference))
            const tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(openingTicketPurposeReference, criteria.tags), defaultTagAggregation(openingTicketPurposeReference, criteria.tags))
            const filteredTags = tagAggregation.sort((a, b) => b.count - a.count).map((a) => a.tag)
            const filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(openingTicketPurposeReference, criteria.category), []).map((a) => a.category)
            const categorySource = categoryOrTagMatcher(filteredCategories)
            const tagSource = categoryOrTagMatcher(filteredTags)
            const query = null

            categorySource(query, (categoryMatches) => {
                tagSource(query, (tagMatches) => {
                    this.setState({sortedOpeningTicketPurposes, categorySource, tagSource, query, categoryMatches, tagMatches, activeOpeningTicketPurpose: nextActiveOpeningTicketPurpose})
                })
            })
        }
    }

    _filter(criteriaUpdate) {
        const {openingTicketPurposeReference} = this.props
        const {criteria} = this.state

        const nextCriteria = {...criteria, ...criteriaUpdate}

        const openingTicketPurposes = [...openingTicketPurposeReference.openingTicketPurposes, openingTicketPurposeReference.default.openingTicketPurpose]
        const filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(OpeningTicketPurposeRef.expendChildrenCategories(openingTicketPurposeReference, nextCriteria.category), nextCriteria.tags))
        const sortedOpeningTicketPurposes = filteredOpeningTicketPurposes.sort(openingTicketPurposeSorter(openingTicketPurposeReference))
        const tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(openingTicketPurposeReference, nextCriteria.tags), defaultTagAggregation(openingTicketPurposeReference, nextCriteria.tags))
        const filteredTags = tagAggregation.sort((a, b) => b.count - a.count).map((a) => a.tag)
        const filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(openingTicketPurposeReference, nextCriteria.category), []).map((a) => a.category)
        const categorySource = categoryOrTagMatcher(filteredCategories)
        const tagSource = categoryOrTagMatcher(filteredTags)
        const query = null

        categorySource(query, (categoryMatches) => {
            tagSource(query, (tagMatches) => {
                this.setState({sortedOpeningTicketPurposes, categorySource, tagSource, query, categoryMatches, tagMatches, criteria: nextCriteria})
            })
        })
    }

    _match(event) {
        const {categorySource, tagSource} = this.state
        const query = event.target.value || null

        categorySource(query, (categoryMatches) => {
            tagSource(query, (tagMatches) => {
                this.setState({query, categoryMatches, tagMatches})
            })
        })
    }

    _clear(event) {
        const {categorySource, tagSource} = this.state
        const query = null

        event.preventDefault()

        categorySource(query, (categoryMatches) => {
            tagSource(query, (tagMatches) => {
                this.setState({query, categoryMatches, tagMatches})
            })
        })
    }

    _openPanel(key) {
        const {activeKey} = this.state

        const nextActiveKey = activeKey != key && key || null
        this.setState({activeKey: nextActiveKey})
    }

    _openModal(event, result, value) {
        event.preventDefault()

        const openedModal = modalName(result)
        const {activeCategory, activeTag, activeOpeningTicketPurpose, activeActivity} = activeValues(result, value)

        this._openedModalDeferred = new ModalDeferred(result)
        this.setState({openedModal, activeCategory, activeTag, activeOpeningTicketPurpose, activeActivity})

        return this._openedModalDeferred.promise
    }

    _closeModal(event, result, value) {
        if (event) {
            event.preventDefault()
        }

        if (this._openedModalDeferred) {
            this._openedModalDeferred.resolve(result, value)
            this._openedModalDeferred = null
        }

        this.setState({
            openedModal: null,
            activeCategory: null,
            activeTag: null,
            activeOpeningTicketPurpose: null,
            activeActivity: null
        })
    }

    render() {
        const {openingTicketPurposeReference, activityReference} = this.props
        const {sortedOpeningTicketPurposes, query, categoryMatches, tagMatches, criteria, activeKey, openedModal, activeCategory, activeTag, activeOpeningTicketPurpose, activeActivity} = this.state

        const displayCategory = (category, active, path) => {
            return (
                <div className={style.category}>
                    <IconCateg iconId={category.iconId} exponent={active && 'X'}/>
                    <label>{category.label}</label>
                    {path && (
                        <small>></small>
                    )}
                </div>
            )
        }

        const displayTag = (tag, active) => {
            return (
                <div className={style.tag}>
                    <IconCateg iconId={tag.iconId} exponent={active && 'X'}/>
                    <label>{tag.label}</label>
                </div>
            )
        }

        const inputButton = query && (
            <Button
                onClick={(e) => this._clear(e)}>
                <Icon icon='cross' size='xs' />
            </Button>
        )

        const inputAddon = !query && (
            <Icon icon='search' size='xs' />
        )

        const categoryPathField = () => {
            const value = OpeningTicketPurposeRef.expendParentCategories(openingTicketPurposeReference, criteria.category)

            const onChange = (categories) => {
                const category = OpeningTicketPurposeRef.getLeafCategory(categories)
                this._filter({category})
            }

            return {value, onChange}
        }

        return (
            <div>
                <Row>
                    <Col sm={8}>
                        <div className={style.main}>
                            <div className={style.categoryTagSection}>
                                <ButtonToggle multi
                                    identify={(c) => c.uid}
                                    {...categoryPathField()}>
                                    <ul className={cx(style.categoryTagGroup, style.categoryGroup)}>
                                        {OpeningTicketPurposeRef.expendParentCategories(openingTicketPurposeReference, criteria.category).map((category, index, array) => (
                                            <li key={category.uid}>
                                                <Button
                                                    bsStyle='link'
                                                    value={category}
                                                    disabled={index < array.length - 1}>
                                                    {displayCategory(category, index == array.length - 1, true)}
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </ButtonToggle>
                                <ButtonToggle multi
                                    identify={(t) => t.uid}
                                    value={criteria.tags}
                                    onChange={(tags) => this._filter({tags})}>
                                    <ul className={style.categoryTagGroup}>
                                        {criteria.tags.map((tag) => (
                                            <li key={tag.uid}>
                                                <Button
                                                    bsStyle='link'
                                                    value={tag}>
                                                    {displayTag(tag, true)}
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </ButtonToggle>
                            </div>
                            <PanelGroup accordion
                                activeKey={activeKey}
                                onSelect={(k) => this._openPanel(k)}>
                                {sortedOpeningTicketPurposes.map((openingTicketPurpose) => (
                                    <UpdateOpeningTicketPurposePanel
                                        key={openingTicketPurpose.uid}
                                        eventKey={openingTicketPurpose.uid}
                                        bsStyle={OpeningTicketPurposeRef.isDefaultOpeningTicketPurpose(openingTicketPurposeReference, openingTicketPurpose) && 'info'}
                                        openingTicketPurposeReference={openingTicketPurposeReference}
                                        activityReference={activityReference}
                                        openingTicketPurpose={openingTicketPurpose}
                                        onSubmit={(e, r, cot) => this._openModal(e, r, cot)} />
                                ))}
                                {activeKey == 'new' && (
                                    <CreateOpeningTicketPurposePanel
                                        eventKey='new'
                                        reference={openingTicketPurposeReference}
                                        onSubmit={(e, r, cot) => this._openModal(e, r, cot)} />
                                )}
                            </PanelGroup>
                            {activeKey != 'new' && (
                                <ButtonToolbar>
                                    <Button
                                        bsStyle='primary'
                                        bsSize='large'
                                        onClick={() => this._openPanel('new')}>
                                        {i18n.newOpeningTicketPurpose}
                                    </Button>
                                </ButtonToolbar>
                            )}
                        </div>
                    </Col>
                    <Col sm={4}>
                        <div className={style.side}>
                            <h4>{sortedOpeningTicketPurposes.length} {i18n.openingTicketPurposes}</h4>
                            <Input
                                type='text'
                                buttonAfter={inputButton}
                                addonAfter={inputAddon}
                                placeholder={i18n.searchOpeningTicketPurpose}
                                value={query}
                                onChange={(e) => this._match(e)} />
                            <ButtonToggle
                                identify={(c) => c.uid}
                                value={criteria.category}
                                onChange={(category) => this._filter({category})}>
                                <ul className={cx(style.categoryTagGroup, style.categoryGroup)}>
                                    {categoryMatches.map((category) => (
                                        <li key={category.uid}>
                                            <Button
                                                bsStyle='link'
                                                value={category}>
                                                {displayCategory(category)}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            </ButtonToggle>
                            <ButtonToggle multi
                                identify={(t) => t.uid}
                                value={criteria.tags}
                                onChange={(ts) => this._filter(defaultTagCriteria(openingTicketPurposeReference, ts))}>
                                <ul className={style.categoryTagGroup}>
                                    {tagMatches.map((tag) => (
                                        <li key={tag.uid}>
                                            <Button
                                                bsStyle='link'
                                                value={tag}>
                                                {displayTag(tag)}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            </ButtonToggle>
                        </div>
                    </Col>
                </Row>
                <CreateUpdateTagModal
                    tag={activeTag}
                    show={openedModal == 'CreateUpdateTagModal'}
                    onHide={(e, r, t) => this._closeModal(e, r, t)} />
                <CreateUpdateCategoryModal
                    category={activeCategory}
                    show={openedModal == 'CreateUpdateCategoryModal'}
                    onHide={(e, r, c) => this._closeModal(e, r, c)} />
                {activeOpeningTicketPurpose && (
                    <AssociateActivityWithOpeningTicketPurposeModal
                        openingTicketPurpose={activeOpeningTicketPurpose}
                        show={openedModal == 'AssociateActivityWithOpeningTicketPurposeModal'}
                        onHide={(e) => this._closeModal(e)}/>
                )}
                {activeOpeningTicketPurpose && activeActivity && (
                    <DissociateActivityFromOpeningTicketPurposeModal
                        openingTicketPurpose={activeOpeningTicketPurpose}
                        activity={activeActivity}
                        show={openedModal == 'DissociateActivityFromOpeningTicketPurposeModal'}
                        onHide={(e) => this._closeModal(e)}/>
                )}
                {activeOpeningTicketPurpose && (
                    <EnableDisableOpeningTicketPurposeModal
                        openingTicketPurpose={activeOpeningTicketPurpose}
                        show={openedModal == 'EnableDisableOpeningTicketPurposeModal'}
                        onHide={(e) => this._closeModal(e)}/>
                )}
            </div>
        )
    }
}

OpeningTicketPurposePanelGroup = connect((state) => ({
    openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
    activityReference: state.reference.activityRef
}))(OpeningTicketPurposePanelGroup)

export default OpeningTicketPurposePanelGroup


// WEBPACK FOOTER //
// ./lib/reference/components/OpeningTicketPurposePanelGroup.js